import { registerComponent } from '@gig/magic-common';
import SmsVerificationComponent from './sms.vue.js';

var SmsVerification = registerComponent(SmsVerificationComponent);

export { SmsVerification };
